import { DEFAULT_LANGUAGE_CODE, normalizeLanguageCode } from '../utils/language';

const siteMessages = {
  uz: {
    navbar: {
      topbarInfo: {
        location: 'Farg‘ona shahri, A.Navoiy ko‘chasi 55-B uy',
        phone: '+998954019454, +998954019457',
        email: 'info@ukiu.uz'
      },
      topbarLinks: {
        lms: 'LMS',
        hemis: 'HEMIS',
        corporateEmail: 'KORPORATIV POCHTA',
        eLibrary: 'E-KUTUBXONA'
      },
      brand: {
        sub: 'Korea International University in Fergana',
        korean: '우즈베키스탄 한국국제대학교'
      },
      contact: 'Aloqa',
      openContact: "Murojaatlar oynasini ochish",
      mobileMenu: 'Menu',
      openSectionSuffix: 'bo‘limini ochish'
    },
    academicSidebar: {
      title: 'Akademik menyu',
      announcementsTitle: 'OTM E’lonlari',
      viewAll: 'Barchasi',
      emptyAnnouncements: 'Hozircha e’lonlar mavjud emas.',
      searchPlaceholder: 'Menyudan qidirish',
      searchEmpty: 'Mos menu topilmadi.',
      items: {
        faculties: 'Fakultetlar',
        departments: 'Kafedralar',
        sections: 'Bo‘limlar',
        partners: 'Xalqaro hamkorlik',
        news: 'Yangiliklar',
        administration: 'Ma’muriyat'
      }
    },
    pages: {
      dynamicPage: {
        label: 'KIUF SAHIFALARI',
        notFoundTitle: 'Sahifa topilmadi',
        notFoundText: 'So‘ralgan sahifa mavjud emas yoki hozircha faol holatda emas.',
        backHome: 'Bosh sahifaga qaytish',
        intro: '',
        emptyContent: 'Bu sahifa uchun matn hali joylanmagan.'
      },
      menuContent: {
        label: 'MENU MA’LUMOTLARI',
        notFoundTitle: 'Menu topilmadi',
        notFoundText: 'So‘ralgan menu mavjud emas yoki hozircha faol holatda emas.',
        backHome: 'Bosh sahifaga qaytish',
        intro: '',
        emptyContent: 'Bu menu uchun matn hali joylanmagan.'
      },
      linkedInfoTable: {
        eyebrow: 'Tarkibiy sahifalar',
        action: 'O‘tish'
      },
      fileAttachments: {
        eyebrow: 'Biriktirilgan fayllar',
        title: 'Yuklab olish uchun hujjatlar',
        action: 'Yuklab olish',
        typeLabel: 'Turi',
        sizeLabel: 'Hajmi',
        defaultTitle: 'Fayl'
      },
      innerBanner: {
        newsDetail: { eyebrow: 'KIUF YANGILIKLARI', title: 'Yangilik tafsiloti' },
        announcementDetail: { eyebrow: 'KIUF E’LONLARI', title: 'E’lon tafsiloti' },
        dynamicPage: { eyebrow: 'KIUF SAHIFALARI', title: 'Sahifa tafsiloti' },
        menuPage: { eyebrow: 'KIUF MENYUSI', title: 'Menu sahifasi' },
        employeeProfile: { eyebrow: 'HODIMLAR PORTFOLIO', title: 'Hodim profili' },
        administration: {
          eyebrow: 'UNIVERSITET MA’MURIYATI',
          title: 'Ma’muriyat',
          description: 'Universitet boshqaruvi va rahbariyat tarkibi bilan yaqindan tanishing.'
        },
        newsList: { eyebrow: 'KIUF YANGILIKLARI', title: 'Barcha yangiliklar' },
        announcementsList: { eyebrow: 'KIUF E’LONLARI', title: 'Barcha e’lonlar' },
        admission: { eyebrow: 'QABUL', title: 'Qabul 2024', description: 'Qabul bo‘yicha yangilangan ma’lumotlar bilan tanishing.' },
        partners: { eyebrow: 'XALQARO HAMKORLIK', title: 'Global ta’lim hamkorlari' },
        facultyDetail: { eyebrow: 'AKADEMIK TUZILMA', title: 'Fakultet sahifasi' },
        departmentDetail: { eyebrow: 'AKADEMIK TUZILMA', title: 'Kafedra sahifasi' },
        sectionDetail: { eyebrow: 'UNIVERSITET BO‘LIMLARI', title: 'Bo‘lim sahifasi' },
        academicBreadcrumbs: {
          faculty: 'Fakultetlar sahifasi',
          department: 'Kafedralar sahifasi',
          section: 'Bo‘limlar sahifasi'
        },
        sectionsList: { eyebrow: 'UNIVERSITET BO‘LIMLARI', title: 'Barcha bo‘limlar' },
        facultiesList: { eyebrow: 'AKADEMIK TUZILMA', title: 'Barcha fakultetlar' },
        departmentsList: { eyebrow: 'AKADEMIK TUZILMA', title: 'Fakultetlar va kafedralar' },
        students: { eyebrow: 'KIUF TALABALARI', title: 'Bizning talabalarimiz' },
        rector: { eyebrow: 'UNIVERSITET RAHBARIYATI', title: 'Ochiq muloqot — ishonchli kelajak asosi' },
        default: { eyebrow: 'KIUF', title: 'Universitet sahifasi' }
      },
      facultiesList: {
        itemPrefix: 'Fakultet',
        details: 'Batafsil'
      },
      sectionsList: {
        eyebrow: 'UNIVERSITET BO‘LIMLARI',
        title: 'Barcha bo‘limlar',
        description: 'Universitet tarkibidagi bo‘limlar haqida batafsil ma’lumotlar bilan tanishing.',
        emptyTitle: 'Bo‘limlar hali joylanmagan',
        emptyText: 'Admin panelga bo‘limlar qo‘shilgach, ular ushbu sahifada ro‘yxat bo‘lib ko‘rinadi.',
        placeholder: 'Bo‘lim',
        badge: 'Bo‘lim',
        openLabel: 'Bo‘lim sahifasini ochish',
        details: 'Batafsil ko‘rish',
        previous: 'Oldingi',
        next: 'Keyingi'
      },
      departmentsList: {
        departmentsCount: (count) => `${count} ta kafedra faoliyat yuritadi`,
        openFaculty: 'Fakultet sahifasini ochish',
        openDepartment: 'Kafedra sahifasini ochish'
      },
      academicEntity: {
        meta: {
          faculty: {
            eyebrow: 'AKADEMIK TUZILMA',
            label: 'Fakultet',
            backLabel: 'Barcha fakultetlar',
            emptyTitle: 'Fakultet topilmadi'
          },
          department: {
            eyebrow: 'AKADEMIK TUZILMA',
            label: 'Kafedra',
            backLabel: 'Barcha kafedralar',
            emptyTitle: 'Kafedra topilmadi'
          },
          section: {
            eyebrow: 'UNIVERSITET BO‘LIMI',
            label: 'Bo‘lim',
            backLabel: 'Barcha bo‘limlar',
            emptyTitle: 'Bo‘lim topilmadi'
          }
        },
        panelFallbackTitle: 'Bo‘lim',
        summary: {
          pageType: 'Sahifa turi',
          departments: 'Kafedralar',
          attachedMenu: 'Biriktirilgan menu',
          faculty: 'Fakultet',
          status: 'Holati',
          active: 'Faol',
          inactive: 'Nofaol'
        },
        emptyDepartments: 'Bu fakultet uchun hozircha kafedralar joylanmagan.',
        departmentBadge: 'Kafedra',
        departmentDescriptionFallback: 'Kafedra sahifasi orqali batafsil ma’lumotni ko‘rishingiz mumkin.',
        attachedDepartmentsLabel: 'Biriktirilgan kafedralar',
        attachedDepartmentsTitle: 'Kafedralar ro‘yxati',
        attachedDirectionsTitle: "Biriktirilgan yo'nalishlar",
        directionsPanelTitle: "Yo'nalishlar",
        emptyDirections: "Bu kafedra uchun hozircha yo'nalishlar joylanmagan.",
        directionBadge: "Yo'nalish",
        directionLinkLabel: 'Havolani ochish',
        directionEmptyContent: "Bu yo'nalish uchun batafsil ma'lumot hali joylanmagan.",
        directionNoLinkText: 'Havola biriktirilmagan.',
        entityInfoLabel: 'Fakultet ma’lumoti',
        emptyFacultyContent: 'Bu fakultet uchun matn hali joylanmagan.',
        emptyPageContent: 'Bu sahifa uchun matn hali joylanmagan.',
        missingFacultyInfo: 'Ushbu kafedra uchun fakultet ma’lumoti topilmadi.',
        relatedFacultyLabel: 'Tegishli fakultet',
        relatedFacultyFallback: 'Ushbu fakultet haqida batafsil ma’lumot alohida sahifada mavjud.',
        openFacultyPage: 'Fakultet sahifasini ochish',
        emptySections: 'Hozircha bo‘limlar ro‘yxati joylanmagan.',
        sectionBadge: 'Bo‘lim',
        sectionFallback: 'Bo‘lim sahifasida batafsil ma’lumot mavjud.',
        emptyEmployees: 'Bu sahifa uchun hozircha biriktirilgan hodimlar joylanmagan.',
        employeeFallbackPosition: 'Hodim',
        employeeProfileOpen: 'Profilni ko‘rish',
        emptyMenuContent: 'Bu menu uchun matn hali joylanmagan.',
        notFoundText: 'So‘ralgan sahifa mavjud emas yoki hozircha faol holatda emas.',
        pageMenuTitle: 'Sahifa menyusi',
        activeMenuDescription: 'Tanlangan o‘ng menu bo‘limi bo‘yicha ma’lumot quyida ko‘rsatilmoqda.',
        facultyOverviewDescription: 'Avval biriktirilgan kafedralar, uning pastida esa fakultet ma’lumoti ko‘rsatilmoqda.',
        defaultTabTitle: 'Ma’lumotlar',
        facultyAboutTitle: 'Fakultet haqida',
        lastUpdatedLabel: 'So‘nggi yangilanish',
        leaderCardTitles: {
          faculty: 'Fakultet dekani',
          department: 'Kafedra mudiri',
          section: 'Bo‘lim boshlig‘i'
        },
        leaderInlineLabels: {
          faculty: 'Dekan',
          department: 'Kafedra mudiri',
          section: 'Bo‘lim boshlig‘i'
        },
        leaderInfoTitle: 'Ma’lumotlar',
        leaderInfoPositionLabel: 'Lavozim',
        leaderInfoPhoneLabel: 'Telefon',
        leaderInfoEmailLabel: 'Email',
        leaderInfoReceptionLabel: 'Qabul vaqti',
        leaderInfoTelegramLabel: 'Telegram',
        leaderInfoInstagramLabel: 'Instagram',
        leaderContactMissing: 'Ma’lumotlar hali joylanmagan',
        leaderEmptyText: 'Rahbar ma’lumoti hali joylanmagan.',
        leaderProfileAction: 'Batafsil',
        menuFilesEyebrow: 'Biriktirilgan fayllar',
        menuFilesTitle: 'Yuklab olish uchun hujjatlar',
        menuFilesAction: 'Yuklab olish',
        menuFilesTypeLabel: 'Turi',
        menuFilesSizeLabel: 'Hajmi',
        pageOverviewDescription: (label) => `${label} sahifasining asosiy ma’lumoti quyida ko‘rsatilmoqda.`
      },
      partnersPage: {
        heroDescription: 'KIUF Janubiy Koreyaning yetakchi universitetlari bilan akademik hamkorlik, almashinuv dasturlari va ilmiy loyihalarni rivojlantirib bormoqda.',
        heroAction: 'Hamkorlarni ko‘rish',
        partnersStat: 'Hamkor universitet',
        secondaryStat: 'Akademik yo‘nalish',
        listEyebrow: 'HAMKORLAR RO‘YXATI',
        listTitle: 'Universitetlar',
        listDescription: 'Har bir hamkor universitet kartasidan uning rasmiy veb-saytiga o‘tishingiz mumkin.',
        partnerBadge: 'Hamkor universitet',
        officialSite: 'Rasmiy sayt',
        formatsEyebrow: 'HAMKORLIK YO‘NALISHLARI',
        formatsTitle: 'Asosiy formatlar',
        formatsDescription: 'Xalqaro aloqalar universitetning ilmiy, o‘quv va amaliy faoliyatida muhim o‘rin egallaydi.',
        collaborationAreas: [
          'Akademik almashinuv va qo‘shma dasturlar',
          'Professor-o‘qituvchilar bilan tajriba almashish',
          'Tadqiqot va innovatsion loyihalarda muloqot',
          'Talabalar uchun xalqaro ta’lim muhiti'
        ]
      },
      newsList: {
        details: 'Batafsil',
        previous: 'Oldingi',
        next: 'Keyingi'
      },
      newsDetail: {
        notFoundTitle: 'Yangilik topilmadi',
        backToList: 'Barcha yangiliklar',
        label: 'KIUF YANGILIKLARI',
        emptyContent: 'Yangilik matni mavjud emas.'
      },
      announcementsList: {
        eyebrow: 'KIUF E’LONLARI',
        title: 'Barcha e’lonlar',
        description: 'Universitetga oid rasmiy e’lonlar va muhim xabarlar.',
        details: 'Batafsil',
        previous: 'Oldingi',
        next: 'Keyingi'
      },
      announcementDetail: {
        notFoundTitle: 'E’lon topilmadi',
        backToList: 'Barcha e’lonlar',
        label: 'Rasmiy e’lon',
        emptyContent: 'E’lon matni mavjud emas.'
      },
      studentsPage: {
        eyebrow: 'KIUF TALABALARI',
        title: 'Bizning talabalarimiz',
        description: 'KIUF talabalari o‘z yo‘nalishida bilim, amaliy tajriba va xalqaro imkoniyatlar orqali rivojlanmoqda.',
        emptyTitle: 'Talabalar hali joylanmagan',
        emptyText: 'Admin panelga talabalar qo‘shilgach, ularning rasmi, yo‘nalishi va fikrlari shu sahifada ko‘rinadi.',
        previewFallback: 'Talaba fikri tez orada shu yerda ko‘rinadi.',
        featuredLabel: 'Tanlangan talaba',
        studentsCountLabel: 'Jami talabalar',
        currentPageLabel: 'Joriy sahifa',
        currentViewLabel: 'Ko‘rsatilmoqda',
        latestStoriesLabel: 'Talabalar hikoyalari',
        openProfileLabel: 'Profilni ochish',
        open: 'Batafsil',
        close: 'Yopish',
        emptyContent: 'Talaba fikri kiritilmagan.'
      },
      employeeProfilePage: {
        eyebrow: 'HODIMLAR PORTFOLIO',
        notFoundTitle: 'Profil topilmadi',
        notFoundText: 'So‘ralgan hodim profili mavjud emas yoki hozircha faol holatda emas.',
        backHome: 'Bosh sahifaga qaytish',
        homeLabel: 'Bosh sahifa',
        attachedFacultyPage: 'Fakultet sahifasi',
        attachedDepartmentPage: 'Kafedra sahifasi',
        attachedSectionPage: 'Bo‘lim sahifasi',
        attachLabels: {
          faculty: 'Fakultet',
          department: 'Kafedra',
          section: 'Bo‘lim'
        },
        profileFallback: 'Hodim profili',
        profileSectionLabel: 'PROFILE',
        emptyContent: 'Bu hodim uchun batafsil ma’lumot hali joylanmagan.',
        portfolioBadge: 'Portfolio',
        portfolioTitle: 'Hodim profili',
        portfolioDescription: 'Tanlangan hodimning lavozimi, bog‘langan sahifasi va batafsil ma’lumotlari shu yerda ko‘rsatiladi.',
        telegram: 'Telegram',
        instagram: 'Instagram'
      },
      administrationPage: {
        eyebrow: 'UNIVERSITET MA’MURIYATI',
        title: 'Ma’muriyat',
        description: 'Universitet boshqaruvi va rahbariyat tarkibi bilan yaqindan tanishing.',
        featuredLabel: 'Asosiy profil',
        membersLabel: 'Ma’muriyat a’zolari',
        openProfile: 'Profilni ochish',
        contactLabel: 'Bog‘lanish',
        activeLabel: 'Faol profil',
        leadershipLabel: 'Rahbar roli',
        unitsLabel: 'Biriktirilgan bo‘limlar',
        emptyTitle: 'Ma’muriyat profillari hali tayyor emas',
        emptyText: 'Ma’muriyat a’zolari tez orada shu yerda e’lon qilinadi.',
        fallbackPosition: 'Ma’muriyat a’zosi',
        readMore: 'Batafsil',
        administrationBadge: 'Ma’muriyat',
        quickContact: 'Tez bog‘lanish',
        portfolioLabel: 'Portfolio',
        emailLabel: 'Email',
        receptionLabel: 'Qabul vaqti',
        phoneLabel: 'Telefon'
      },
      admissionPage: {
        label: 'QABUL 2024',
        title: 'Qabul 2024',
        description: 'Admin panelda kiritilgan qabul bo‘yicha ma’lumotlar shu sahifada ko‘rsatiladi.',
        emptyContent: 'Qabul bo‘yicha ma’lumot hali joylanmagan.',
        action: 'Ariza topshirish'
      }
    },
    home: {
      heroBanner: {
        primaryButton: 'Batafsil',
        secondaryButton: 'Ko‘rish',
        ariaLabel: 'KIUF bannerlari',
        slideLabel: 'Banner',
        pauseSlides: 'Avtomatik almashishni to‘xtatish',
        resumeSlides: 'Avtomatik almashishni davom ettirish',
        previousSlide: 'Oldingi slayd',
        nextSlide: 'Keyingi slayd'
      },
      heroFeatures: {
        ariaLabel: 'KIUF afzalliklari'
      },
      homeInfo: {
        newsTitle: 'Yangiliklar',
        directionsTitle: 'Yo‘nalishlar',
        seeAll: 'Barchasi',
        noDate: 'Sana yo‘q',
        newsEmptyTitle: 'Yangiliklar hali qo‘shilmagan.',
        newsEmptyAction: 'Bo‘limga o‘tish',
        directionsEmptyTitle: 'Yo‘nalishlar hali qo‘shilmagan.',
        directionsEmptyAction: 'Bo‘limga o‘tish',
        directionsPromoTag: 'Yo‘nalishlar',
        directionsPromoTitle: 'Yo‘nalishlar bu yerda ko‘rinadi',
        directionsPromoText:
          'Admin paneldan yo‘nalish qo‘shilgandan keyin ushbu bo‘lim avtomatik yangilanadi.',
        facultyFallbackTitle: 'Fakultet',
        newsFallbackTitle: 'Yangilik',
        admissionTitle: 'Qabul 2024',
        admissionText: 'Hozir ariza topshiring va kelajagingizga ilk qadamni qo‘ying!',
        admissionButton: 'Onlayn ariza',
        detailsAction: 'Batafsil',
        directionPromoFallback: 'Yo‘nalish haqida batafsil ma’lumotni ochishingiz mumkin.',
        directionOrderTag: (order) => `${order}-yo‘nalish`,
        departmentCountTag: (departmentsCount) => `${departmentsCount} ta kafedra`,
        facultyPromoText: (departmentsCount) =>
          `${departmentsCount} ta kafedra bilan ushbu fakultet haqida batafsil ma’lumotni ko‘ring.`
      },
      rector: {
        miniTitle: 'REKTOR MUROJAATI',
        defaultTitle: 'Rektor murojaati',
        defaultExcerpt: 'Rektor murojaati matni tez orada joylanadi.',
        cta: 'Batafsil',
        alt: 'Universitet rektori',
        defaultName: 'Rektor'
      },
      studentAnnouncementStats: {
        announcementsTitle: 'E’lonlar',
        studentsTitle: 'Iqtidorli talabalarimiz',
        seeAll: 'Barchasi',
        announcementsEmptyTitle: 'E’lonlar hozircha mavjud emas',
        announcementsEmptyText: 'Yangi e’lonlar qo‘shilgach shu yerda ko‘rinadi.',
        studentsEmptyTitle: 'Talabalar hali kiritilmagan',
        studentsEmptyText: 'Admin panel orqali qo‘shilgan talabalar shu blokda chiqadi.',
        details: 'Batafsil',
        studentFallback: 'Talaba fikri tez orada joylanadi.'
      },
      partners: {
        sectionLabel: 'Xalqaro hamkorlik',
        sectionTitle: 'Hamkorlarimiz',
        seeAll: 'Barchasi',
        description:
          'KIUF hamkor universitetlari bilan akademik almashinuv, qo‘shma loyihalar va talabalar uchun xalqaro imkoniyatlarni kengaytirmoqda.',
        ariaLabel: 'Hamkorlarimiz',
        siteVisitSuffix: 'saytiga o‘tish',
        logoSuffix: 'logotipi'
      },
      statistics: {
        label: 'QISQACHA RAQAMLAR',
        title: 'Talabalar va Xodimlar hajmi'
      }
    },
    footer: {
      brandDescription:
        'KIUF — O‘zbekiston va Koreya o‘rtasidagi ta’lim ko‘prigi. Zamonaviy ta’lim, xalqaro hamkorlik va kelajak sari ishonchli qadam.',
      columns: [
        {
          title: 'Universitet',
          links: ['Biz haqimizda', 'Rahbariyat', 'Tuzilma', 'Vakansiyalar']
        }
      ],
      contactTitle: 'Aloqa',
      addressLabel: 'Manzil:',
      addressValue: 'Farg‘ona shahri, A.Navoiy ko‘chasi 55-B uy',
      phoneLabel: 'Telefon:',
      phoneValue: '+998954019454, +998954019457',
      emailLabel: 'Email:',
      emailValue: 'info@ukiu.uz',
      hoursLabel: 'Ish vaqti:',
      hoursValue: 'Dushanba - Juma, 9:00 dan 18:00 gacha',
      applyButton: 'Onlayn ariza topshirish',
      copyright: '© 2024 KIUF. Barcha huquqlar himoyalangan.',
      privacy: 'Maxfiylik siyosati',
      terms: 'Foydalanish shartlari',
      mapTitle: 'KIUF xaritasi'
    }
  },
  ru: {
    navbar: {
      topbarInfo: {
        location: 'г. Фергана, ул. А. Навои, дом 55-Б',
        phone: '+998954019454, +998954019457',
        email: 'info@ukiu.uz'
      },
      topbarLinks: {
        lms: 'LMS',
        hemis: 'HEMIS',
        corporateEmail: 'KORPORATIV POCHTA',
        eLibrary: 'E-KUTUBXONA'
      },
      brand: {
        sub: 'Korea International University in Fergana',
        korean: '우즈베키스탄 한국국제대학교'
      },
      contact: 'Связь',
      openContact: 'Открыть окно обращений',
      mobileMenu: 'Меню',
      openSectionSuffix: 'открыть раздел'
    },
    academicSidebar: {
      title: 'Академическое меню',
      announcementsTitle: 'Объявления вуза',
      viewAll: 'Все',
      emptyAnnouncements: 'Объявлений пока нет.',
      searchPlaceholder: 'Поиск по меню',
      searchEmpty: 'Подходящее меню не найдено.',
      items: {
        faculties: 'Факультеты',
        departments: 'Кафедры',
        sections: 'Отделы',
        partners: 'Международное сотрудничество',
        news: 'Новости',
        administration: 'Администрация'
      }
    },
    pages: {
      dynamicPage: {
        label: 'СТРАНИЦЫ KIUF',
        notFoundTitle: 'Страница не найдена',
        notFoundText: 'Запрошенная страница не существует или сейчас неактивна.',
        backHome: 'Вернуться на главную',
        intro: 'Информация отображается в том порядке, в котором она сохранена на странице.',
        emptyContent: 'Для этой страницы текст пока не добавлен.'
      },
      menuContent: {
        label: 'ДАННЫЕ МЕНЮ',
        notFoundTitle: 'Меню не найдено',
        notFoundText: 'Запрошенное меню не существует или сейчас неактивно.',
        backHome: 'Вернуться на главную',
        intro: '',
        emptyContent: 'Для этого меню текст пока не добавлен.'
      },
      linkedInfoTable: {
        eyebrow: 'Структурные страницы',
        action: 'Открыть'
      },
      fileAttachments: {
        eyebrow: 'Прикреплённые файлы',
        title: 'Документы для скачивания',
        action: 'Скачать',
        typeLabel: 'Тип',
        sizeLabel: 'Размер',
        defaultTitle: 'Файл'
      },
      innerBanner: {
        newsDetail: { eyebrow: 'НОВОСТИ KIUF', title: 'Подробности новости' },
        announcementDetail: { eyebrow: 'ОБЪЯВЛЕНИЯ KIUF', title: 'Подробности объявления' },
        dynamicPage: { eyebrow: 'СТРАНИЦЫ KIUF', title: 'Подробности страницы' },
        menuPage: { eyebrow: 'МЕНЮ KIUF', title: 'Страница меню' },
        employeeProfile: { eyebrow: 'ПОРТФОЛИО СОТРУДНИКОВ', title: 'Профиль сотрудника' },
        administration: {
          eyebrow: 'АДМИНИСТРАЦИЯ УНИВЕРСИТЕТА',
          title: 'Администрация',
          description: 'Познакомьтесь с руководством и административной командой университета.'
        },
        newsList: { eyebrow: 'НОВОСТИ KIUF', title: 'Все новости' },
        announcementsList: { eyebrow: 'ОБЪЯВЛЕНИЯ KIUF', title: 'Все объявления' },
        admission: { eyebrow: 'ПРИЁМ', title: 'Приём 2024', description: 'Ознакомьтесь с актуальной информацией о приёме.' },
        partners: { eyebrow: 'МЕЖДУНАРОДНОЕ СОТРУДНИЧЕСТВО', title: 'Глобальные образовательные партнёры' },
        facultyDetail: { eyebrow: 'АКАДЕМИЧЕСКАЯ СТРУКТУРА', title: 'Страница факультета' },
        departmentDetail: { eyebrow: 'АКАДЕМИЧЕСКАЯ СТРУКТУРА', title: 'Страница кафедры' },
        sectionDetail: { eyebrow: 'УНИВЕРСИТЕТСКИЕ ОТДЕЛЫ', title: 'Страница отдела' },
        academicBreadcrumbs: {
          faculty: 'Страница факультетов',
          department: 'Страница кафедр',
          section: 'Страница отделов'
        },
        sectionsList: { eyebrow: 'УНИВЕРСИТЕТСКИЕ ОТДЕЛЫ', title: 'Все отделы' },
        facultiesList: { eyebrow: 'АКАДЕМИЧЕСКАЯ СТРУКТУРА', title: 'Все факультеты' },
        departmentsList: { eyebrow: 'АКАДЕМИЧЕСКАЯ СТРУКТУРА', title: 'Факультеты и кафедры' },
        students: { eyebrow: 'СТУДЕНТЫ KIUF', title: 'Наши студенты' },
        rector: { eyebrow: 'РУКОВОДСТВО УНИВЕРСИТЕТА', title: 'Открытый диалог — основа уверенного будущего' },
        default: { eyebrow: 'KIUF', title: 'Страница университета' }
      },
      facultiesList: {
        itemPrefix: 'Факультет',
        details: 'Подробнее'
      },
      sectionsList: {
        eyebrow: 'УНИВЕРСИТЕТСКИЕ ОТДЕЛЫ',
        title: 'Все отделы',
        description: 'Ознакомьтесь с подробной информацией об отделах университета.',
        emptyTitle: 'Отделы пока не размещены',
        emptyText: 'После добавления отделов в админ-панели они появятся на этой странице списком.',
        placeholder: 'Отдел',
        badge: 'Отдел',
        openLabel: 'Открыть страницу отдела',
        details: 'Подробнее',
        previous: 'Предыдущая',
        next: 'Следующая'
      },
      departmentsList: {
        departmentsCount: (count) => `Действует ${count} кафедр`,
        openFaculty: 'Открыть страницу факультета',
        openDepartment: 'Открыть страницу кафедры'
      },
      academicEntity: {
        meta: {
          faculty: {
            eyebrow: 'АКАДЕМИЧЕСКАЯ СТРУКТУРА',
            label: 'Факультет',
            backLabel: 'Все факультеты',
            emptyTitle: 'Факультет не найден'
          },
          department: {
            eyebrow: 'АКАДЕМИЧЕСКАЯ СТРУКТУРА',
            label: 'Кафедра',
            backLabel: 'Все кафедры',
            emptyTitle: 'Кафедра не найдена'
          },
          section: {
            eyebrow: 'УНИВЕРСИТЕТСКИЙ ОТДЕЛ',
            label: 'Отдел',
            backLabel: 'Все отделы',
            emptyTitle: 'Отдел не найден'
          }
        },
        panelFallbackTitle: 'Раздел',
        summary: {
          pageType: 'Тип страницы',
          departments: 'Кафедры',
          attachedMenu: 'Прикреплённое меню',
          faculty: 'Факультет',
          status: 'Статус',
          active: 'Активен',
          inactive: 'Неактивен'
        },
        emptyDepartments: 'Для этого факультета кафедры пока не размещены.',
        departmentBadge: 'Кафедра',
        departmentDescriptionFallback: 'Подробную информацию можно посмотреть на странице кафедры.',
        attachedDepartmentsLabel: 'Прикреплённые кафедры',
        attachedDepartmentsTitle: 'Список кафедр',
        attachedDirectionsTitle: 'Прикреплённые направления',
        directionsPanelTitle: 'Направления',
        emptyDirections: 'Для этой кафедры направления пока не размещены.',
        directionBadge: 'Направление',
        directionLinkLabel: 'Открыть ссылку',
        directionEmptyContent: 'Подробная информация по этому направлению пока не размещена.',
        directionNoLinkText: 'Ссылка не прикреплена.',
        entityInfoLabel: 'Информация о факультете',
        emptyFacultyContent: 'Для этого факультета текст пока не добавлен.',
        emptyPageContent: 'Для этой страницы текст пока не добавлен.',
        missingFacultyInfo: 'Для этой кафедры информация о факультете не найдена.',
        relatedFacultyLabel: 'Связанный факультет',
        relatedFacultyFallback: 'Подробная информация об этом факультете доступна на отдельной странице.',
        openFacultyPage: 'Открыть страницу факультета',
        emptySections: 'Список отделов пока не размещён.',
        sectionBadge: 'Отдел',
        sectionFallback: 'Подробная информация доступна на странице отдела.',
        emptyEmployees: 'Для этой страницы пока не размещены прикреплённые сотрудники.',
        employeeFallbackPosition: 'Сотрудник',
        employeeProfileOpen: 'Открыть профиль',
        emptyMenuContent: 'Для этого меню текст пока не добавлен.',
        notFoundText: 'Запрошенная страница не существует или сейчас неактивна.',
        pageMenuTitle: 'Меню страницы',
        activeMenuDescription: 'Ниже показана информация по выбранному пункту правого меню.',
        facultyOverviewDescription: 'Сначала показаны прикреплённые кафедры, ниже — информация о факультете.',
        defaultTabTitle: 'Информация',
        facultyAboutTitle: 'О факультете',
        lastUpdatedLabel: 'Последнее обновление',
        leaderCardTitles: {
          faculty: 'Декан факультета',
          department: 'Заведующий кафедрой',
          section: 'Руководитель отдела'
        },
        leaderInlineLabels: {
          faculty: 'Декан',
          department: 'Заведующий кафедрой',
          section: 'Руководитель отдела'
        },
        leaderInfoTitle: 'Информация',
        leaderInfoPositionLabel: 'Должность',
        leaderInfoPhoneLabel: 'Телефон',
        leaderInfoEmailLabel: 'Email',
        leaderInfoReceptionLabel: 'Время приёма',
        leaderInfoTelegramLabel: 'Telegram',
        leaderInfoInstagramLabel: 'Instagram',
        leaderContactMissing: 'Информация пока не размещена',
        leaderEmptyText: 'Информация о руководителе пока не размещена.',
        leaderProfileAction: 'Подробнее',
        menuFilesEyebrow: 'Прикреплённые файлы',
        menuFilesTitle: 'Документы для скачивания',
        menuFilesAction: 'Скачать',
        menuFilesTypeLabel: 'Тип',
        menuFilesSizeLabel: 'Размер',
        pageOverviewDescription: (label) => `Ниже показана основная информация страницы «${label}».`
      },
      partnersPage: {
        heroDescription: 'KIUF развивает академическое сотрудничество, программы обмена и научные проекты с ведущими университетами Южной Кореи.',
        heroAction: 'Смотреть партнёров',
        partnersStat: 'Университетов-партнёров',
        secondaryStat: 'Академическое направление',
        listEyebrow: 'СПИСОК ПАРТНЁРОВ',
        listTitle: 'Университеты',
        listDescription: 'С каждой карточки партнёрского университета можно перейти на его официальный сайт.',
        partnerBadge: 'Университет-партнёр',
        officialSite: 'Официальный сайт',
        formatsEyebrow: 'НАПРАВЛЕНИЯ СОТРУДНИЧЕСТВА',
        formatsTitle: 'Основные форматы',
        formatsDescription: 'Международные связи занимают важное место в научной, учебной и практической деятельности университета.',
        collaborationAreas: [
          'Академический обмен и совместные программы',
          'Обмен опытом с профессорско-преподавательским составом',
          'Сотрудничество в исследованиях и инновационных проектах',
          'Международная образовательная среда для студентов'
        ]
      },
      newsList: {
        details: 'Подробнее',
        previous: 'Предыдущая',
        next: 'Следующая'
      },
      newsDetail: {
        notFoundTitle: 'Новость не найдена',
        backToList: 'Все новости',
        label: 'НОВОСТИ KIUF',
        emptyContent: 'Текст новости отсутствует.'
      },
      announcementsList: {
        eyebrow: 'ОБЪЯВЛЕНИЯ KIUF',
        title: 'Все объявления',
        description: 'Официальные объявления и важные сообщения университета.',
        details: 'Подробнее',
        previous: 'Предыдущая',
        next: 'Следующая'
      },
      announcementDetail: {
        notFoundTitle: 'Объявление не найдено',
        backToList: 'Все объявления',
        label: 'Официальное объявление',
        emptyContent: 'Текст объявления отсутствует.'
      },
      studentsPage: {
        eyebrow: 'СТУДЕНТЫ KIUF',
        title: 'Наши студенты',
        description: 'Студенты KIUF развиваются в своём направлении через знания, практический опыт и международные возможности.',
        emptyTitle: 'Студенты пока не размещены',
        emptyText: 'После добавления студентов в админ-панели их фото, направление и отзывы появятся на этой странице.',
        previewFallback: 'Отзыв студента скоро появится здесь.',
        featuredLabel: 'Выбранный студент',
        studentsCountLabel: 'Всего студентов',
        currentPageLabel: 'Текущая страница',
        currentViewLabel: 'Показано',
        latestStoriesLabel: 'Истории студентов',
        openProfileLabel: 'Открыть профиль',
        open: 'Подробнее',
        close: 'Закрыть',
        emptyContent: 'Отзыв студента не добавлен.'
      },
      employeeProfilePage: {
        eyebrow: 'ПОРТФОЛИО СОТРУДНИКОВ',
        notFoundTitle: 'Профиль не найден',
        notFoundText: 'Запрошенный профиль сотрудника не существует или сейчас неактивен.',
        backHome: 'Вернуться на главную',
        homeLabel: 'Главная страница',
        attachedFacultyPage: 'Страница факультета',
        attachedDepartmentPage: 'Страница кафедры',
        attachedSectionPage: 'Страница отдела',
        attachLabels: {
          faculty: 'Факультет',
          department: 'Кафедра',
          section: 'Отдел'
        },
        profileFallback: 'Профиль сотрудника',
        profileSectionLabel: 'PROFILE',
        emptyContent: 'Подробная информация об этом сотруднике пока не добавлена.',
        portfolioBadge: 'Портфолио',
        portfolioTitle: 'Профиль сотрудника',
        portfolioDescription: 'Здесь показаны должность выбранного сотрудника, связанная страница и подробная информация.',
        telegram: 'Telegram',
        instagram: 'Instagram'
      },
      administrationPage: {
        eyebrow: 'АДМИНИСТРАЦИЯ УНИВЕРСИТЕТА',
        title: 'Администрация',
        description: 'Познакомьтесь с руководством и административной командой университета.',
        featuredLabel: 'Основной профиль',
        membersLabel: 'Состав администрации',
        openProfile: 'Открыть профиль',
        contactLabel: 'Контакт',
        activeLabel: 'Активные профили',
        leadershipLabel: 'Руководящие роли',
        unitsLabel: 'Связанные подразделения',
        emptyTitle: 'Профили администрации пока не готовы',
        emptyText: 'Состав администрации скоро будет опубликован здесь.',
        fallbackPosition: 'Сотрудник администрации',
        readMore: 'Подробнее',
        administrationBadge: 'Администрация',
        quickContact: 'Быстрая связь',
        portfolioLabel: 'Портфолио',
        emailLabel: 'Email',
        receptionLabel: 'Время приёма',
        phoneLabel: 'Телефон'
      },
      admissionPage: {
        label: 'ПРИЁМ 2024',
        title: 'Приём 2024',
        description: 'Информация о приёме, введённая в админ-панели, отображается на этой странице.',
        emptyContent: 'Информация о приёме пока не добавлена.',
        action: 'Подать заявку'
      }
    },
    home: {
      heroBanner: {
        primaryButton: 'Подробнее',
        secondaryButton: 'Смотреть',
        ariaLabel: 'Баннеры KIUF',
        slideLabel: 'Баннер',
        pauseSlides: 'Приостановить смену баннеров',
        resumeSlides: 'Продолжить смену баннеров',
        previousSlide: 'Предыдущий слайд',
        nextSlide: 'Следующий слайд'
      },
      heroFeatures: {
        ariaLabel: 'Преимущества KIUF'
      },
      homeInfo: {
        newsTitle: 'Новости',
        directionsTitle: 'Направления',
        seeAll: 'Все',
        noDate: 'Дата не указана',
        newsEmptyTitle: 'Новости пока не добавлены.',
        newsEmptyAction: 'Перейти в раздел',
        directionsEmptyTitle: 'Направления пока не добавлены.',
        directionsEmptyAction: 'Перейти в раздел',
        directionsPromoTag: 'Направления',
        directionsPromoTitle: 'Направления появятся здесь',
        directionsPromoText:
          'После добавления направлений в админ-панели этот раздел обновится автоматически.',
        facultyFallbackTitle: 'Факультет',
        newsFallbackTitle: 'Новость',
        admissionTitle: 'Приём 2024',
        admissionText: 'Подайте заявку сейчас и сделайте первый шаг к своему будущему!',
        admissionButton: 'Онлайн-заявка',
        detailsAction: 'Подробнее',
        directionPromoFallback: 'Можно открыть подробную информацию по этому направлению.',
        directionOrderTag: (order) => `${order}-е направление`,
        departmentCountTag: (departmentsCount) => `${departmentsCount} кафедр`,
        facultyPromoText: (departmentsCount) =>
          `Ознакомьтесь с факультетом, в составе которого ${departmentsCount} кафедр.`
      },
      rector: {
        miniTitle: 'ОБРАЩЕНИЕ РЕКТОРА',
        defaultTitle: 'Обращение ректора',
        defaultExcerpt: 'Текст обращения ректора скоро будет опубликован.',
        cta: 'Подробнее',
        alt: 'Ректор университета',
        defaultName: 'Ректор'
      },
      studentAnnouncementStats: {
        announcementsTitle: 'Объявления',
        studentsTitle: 'Талантливые студенты',
        seeAll: 'Все',
        announcementsEmptyTitle: 'Объявлений пока нет',
        announcementsEmptyText: 'Новые объявления появятся здесь после добавления.',
        studentsEmptyTitle: 'Студенты ещё не добавлены',
        studentsEmptyText: 'Студенты, добавленные через админ-панель, будут показаны здесь.',
        details: 'Подробнее',
        studentFallback: 'Отзыв студента скоро будет опубликован.'
      },
      partners: {
        sectionLabel: 'Международное сотрудничество',
        sectionTitle: 'Наши партнёры',
        seeAll: 'Все',
        description:
          'KIUF расширяет академические обмены, совместные проекты и международные возможности для студентов вместе с университетами-партнёрами.',
        ariaLabel: 'Наши международные партнёры',
        siteVisitSuffix: 'перейти на сайт',
        logoSuffix: 'логотип'
      },
      statistics: {
        label: 'КРАТКИЕ ЦИФРЫ',
        title: 'Масштаб студентов и сотрудников'
      }
    },
    footer: {
      brandDescription:
        'KIUF — образовательный мост между Узбекистаном и Кореей. Современное образование, международное сотрудничество и уверенный шаг в будущее.',
      columns: [
        {
          title: 'Университет',
          links: ['О нас', 'Руководство', 'Структура', 'Вакансии']
        }
      ],
      contactTitle: 'Контакты',
      addressLabel: 'Адрес:',
      addressValue: 'г. Фергана, ул. А. Навои, дом 55-Б',
      phoneLabel: 'Телефон:',
      phoneValue: '+998954019454, +998954019457',
      emailLabel: 'Email:',
      emailValue: 'info@ukiu.uz',
      hoursLabel: 'Часы работы:',
      hoursValue: 'Понедельник - Пятница, с 8:00 до 18:00',
      applyButton: 'Подать онлайн-заявку',
      copyright: '© 2024 KIUF. Все права защищены.',
      privacy: 'Политика конфиденциальности',
      terms: 'Условия использования',
      mapTitle: 'Карта KIUF'
    }
  },
  en: {
    navbar: {
      topbarInfo: {
        location: '55-B A. Navoiy Street, Fergana',
        phone: '+998954019454, +998954019457',
        email: 'info@ukiu.uz'
      },
      topbarLinks: {
        lms: 'LMS',
        hemis: 'HEMIS',
        corporateEmail: 'CORPORATE EMAIL',
        eLibrary: 'E-LIBRARY'
      },
      brand: {
        sub: 'Korea International University in Fergana',
        korean: '우즈베키스탄 한국국제대학교'
      },
      contact: 'Contact',
      openContact: 'Open appeals window',
      mobileMenu: 'Menu',
      openSectionSuffix: 'open section'
    },
    academicSidebar: {
      title: 'Academic Menu',
      announcementsTitle: 'University Announcements',
      viewAll: 'View all',
      emptyAnnouncements: 'No announcements yet.',
      searchPlaceholder: 'Search menu',
      searchEmpty: 'No matching menu found.',
      items: {
        faculties: 'Faculties',
        departments: 'Departments',
        sections: 'Sections',
        partners: 'International Cooperation',
        news: 'News',
        administration: 'Administration'
      }
    },
    pages: {
      dynamicPage: {
        label: 'KIUF PAGES',
        notFoundTitle: 'Page not found',
        notFoundText: 'The requested page does not exist or is currently inactive.',
        backHome: 'Back to home',
        intro: 'The information is displayed in the same order it was saved on the page.',
        emptyContent: 'No text has been added for this page yet.'
      },
      menuContent: {
        label: 'MENU CONTENT',
        notFoundTitle: 'Menu not found',
        notFoundText: 'The requested menu does not exist or is currently inactive.',
        backHome: 'Back to home',
        intro: '',
        emptyContent: 'No text has been added for this menu yet.'
      },
      linkedInfoTable: {
        eyebrow: 'Structural pages',
        action: 'Open'
      },
      fileAttachments: {
        eyebrow: 'Attached files',
        title: 'Documents for download',
        action: 'Download',
        typeLabel: 'Type',
        sizeLabel: 'Size',
        defaultTitle: 'File'
      },
      innerBanner: {
        newsDetail: { eyebrow: 'KIUF NEWS', title: 'News details' },
        announcementDetail: { eyebrow: 'KIUF ANNOUNCEMENTS', title: 'Announcement details' },
        dynamicPage: { eyebrow: 'KIUF PAGES', title: 'Page details' },
        menuPage: { eyebrow: 'KIUF MENU', title: 'Menu page' },
        employeeProfile: { eyebrow: 'EMPLOYEE PORTFOLIO', title: 'Employee profile' },
        administration: {
          eyebrow: 'UNIVERSITY ADMINISTRATION',
          title: 'Administration',
          description: 'Meet the university leadership and administration team.'
        },
        newsList: { eyebrow: 'KIUF NEWS', title: 'All news' },
        announcementsList: { eyebrow: 'KIUF ANNOUNCEMENTS', title: 'All announcements' },
        admission: { eyebrow: 'ADMISSION', title: 'Admission 2024', description: 'View the latest admission information.' },
        partners: { eyebrow: 'INTERNATIONAL COOPERATION', title: 'Global education partners' },
        facultyDetail: { eyebrow: 'ACADEMIC STRUCTURE', title: 'Faculty page' },
        departmentDetail: { eyebrow: 'ACADEMIC STRUCTURE', title: 'Department page' },
        sectionDetail: { eyebrow: 'UNIVERSITY SECTIONS', title: 'Section page' },
        academicBreadcrumbs: {
          faculty: 'Faculties page',
          department: 'Departments page',
          section: 'Sections page'
        },
        sectionsList: { eyebrow: 'UNIVERSITY SECTIONS', title: 'All sections' },
        facultiesList: { eyebrow: 'ACADEMIC STRUCTURE', title: 'All faculties' },
        departmentsList: { eyebrow: 'ACADEMIC STRUCTURE', title: 'Faculties and departments' },
        students: { eyebrow: 'KIUF STUDENTS', title: 'Our students' },
        rector: { eyebrow: 'UNIVERSITY LEADERSHIP', title: 'Open dialogue is the basis of a confident future' },
        default: { eyebrow: 'KIUF', title: 'University page' }
      },
      facultiesList: {
        itemPrefix: 'Faculty',
        details: 'Details'
      },
      sectionsList: {
        eyebrow: 'UNIVERSITY SECTIONS',
        title: 'All sections',
        description: 'Explore detailed information about the university sections.',
        emptyTitle: 'Sections have not been published yet',
        emptyText: 'Once sections are added in the admin panel, they will appear on this page as a list.',
        placeholder: 'Section',
        badge: 'Section',
        openLabel: 'Open section page',
        details: 'View details',
        previous: 'Previous',
        next: 'Next'
      },
      departmentsList: {
        departmentsCount: (count) => `${count} departments are active`,
        openFaculty: 'Open faculty page',
        openDepartment: 'Open department page'
      },
      academicEntity: {
        meta: {
          faculty: {
            eyebrow: 'ACADEMIC STRUCTURE',
            label: 'Faculty',
            backLabel: 'All faculties',
            emptyTitle: 'Faculty not found'
          },
          department: {
            eyebrow: 'ACADEMIC STRUCTURE',
            label: 'Department',
            backLabel: 'All departments',
            emptyTitle: 'Department not found'
          },
          section: {
            eyebrow: 'UNIVERSITY SECTION',
            label: 'Section',
            backLabel: 'All sections',
            emptyTitle: 'Section not found'
          }
        },
        panelFallbackTitle: 'Section',
        summary: {
          pageType: 'Page type',
          departments: 'Departments',
          attachedMenu: 'Attached menu',
          faculty: 'Faculty',
          status: 'Status',
          active: 'Active',
          inactive: 'Inactive'
        },
        emptyDepartments: 'No departments have been published for this faculty yet.',
        departmentBadge: 'Department',
        departmentDescriptionFallback: 'You can view detailed information on the department page.',
        attachedDepartmentsLabel: 'Attached departments',
        attachedDepartmentsTitle: 'Departments list',
        attachedDirectionsTitle: 'Attached directions',
        directionsPanelTitle: 'Directions',
        emptyDirections: 'No directions have been attached to this department yet.',
        directionBadge: 'Direction',
        directionLinkLabel: 'Open link',
        directionEmptyContent: 'Detailed information for this direction has not been added yet.',
        directionNoLinkText: 'No link attached.',
        entityInfoLabel: 'Faculty information',
        emptyFacultyContent: 'No text has been added for this faculty yet.',
        emptyPageContent: 'No text has been added for this page yet.',
        missingFacultyInfo: 'Faculty information for this department was not found.',
        relatedFacultyLabel: 'Related faculty',
        relatedFacultyFallback: 'Detailed information about this faculty is available on a separate page.',
        openFacultyPage: 'Open faculty page',
        emptySections: 'The sections list has not been published yet.',
        sectionBadge: 'Section',
        sectionFallback: 'Detailed information is available on the section page.',
        emptyEmployees: 'No employees have been attached to this page yet.',
        employeeFallbackPosition: 'Employee',
        employeeProfileOpen: 'View profile',
        emptyMenuContent: 'No text has been added for this menu yet.',
        notFoundText: 'The requested page does not exist or is currently inactive.',
        pageMenuTitle: 'Page menu',
        activeMenuDescription: 'Information for the selected right-side menu section is shown below.',
        facultyOverviewDescription: 'Attached departments are shown first, followed by the faculty information below.',
        defaultTabTitle: 'Information',
        facultyAboutTitle: 'About the faculty',
        lastUpdatedLabel: 'Last updated',
        leaderCardTitles: {
          faculty: 'Faculty dean',
          department: 'Department head',
          section: 'Section head'
        },
        leaderInlineLabels: {
          faculty: 'Dean',
          department: 'Department head',
          section: 'Section head'
        },
        leaderInfoTitle: 'Information',
        leaderInfoPositionLabel: 'Position',
        leaderInfoPhoneLabel: 'Phone',
        leaderInfoEmailLabel: 'Email',
        leaderInfoReceptionLabel: 'Reception hours',
        leaderInfoTelegramLabel: 'Telegram',
        leaderInfoInstagramLabel: 'Instagram',
        leaderContactMissing: 'Information has not been published yet',
        leaderEmptyText: 'Leader information has not been published yet.',
        leaderProfileAction: 'Learn more',
        menuFilesEyebrow: 'Attached files',
        menuFilesTitle: 'Documents for download',
        menuFilesAction: 'Download',
        menuFilesTypeLabel: 'Type',
        menuFilesSizeLabel: 'Size',
        pageOverviewDescription: (label) => `The main information for the ${label} page is shown below.`
      },
      partnersPage: {
        heroDescription: 'KIUF is continuously developing academic cooperation, exchange programs, and research projects with leading universities in South Korea.',
        heroAction: 'View partners',
        partnersStat: 'Partner universities',
        secondaryStat: 'Academic focus',
        listEyebrow: 'PARTNERS LIST',
        listTitle: 'Universities',
        listDescription: 'Each partner university card includes a link to its official website.',
        partnerBadge: 'Partner university',
        officialSite: 'Official site',
        formatsEyebrow: 'COOPERATION AREAS',
        formatsTitle: 'Main formats',
        formatsDescription: 'International relations play an important role in the university’s academic, educational, and practical activities.',
        collaborationAreas: [
          'Academic exchange and joint programs',
          'Experience sharing with faculty members',
          'Collaboration in research and innovation projects',
          'An international learning environment for students'
        ]
      },
      newsList: {
        details: 'Details',
        previous: 'Previous',
        next: 'Next'
      },
      newsDetail: {
        notFoundTitle: 'News not found',
        backToList: 'All news',
        label: 'KIUF NEWS',
        emptyContent: 'News content is not available.'
      },
      announcementsList: {
        eyebrow: 'KIUF ANNOUNCEMENTS',
        title: 'All announcements',
        description: 'Official university announcements and important notices.',
        details: 'Details',
        previous: 'Previous',
        next: 'Next'
      },
      announcementDetail: {
        notFoundTitle: 'Announcement not found',
        backToList: 'All announcements',
        label: 'Official announcement',
        emptyContent: 'Announcement content is not available.'
      },
      studentsPage: {
        eyebrow: 'KIUF STUDENTS',
        title: 'Our students',
        description: 'KIUF students develop in their fields through knowledge, practical experience, and international opportunities.',
        emptyTitle: 'Students have not been published yet',
        emptyText: 'Once students are added in the admin panel, their photos, direction, and feedback will appear on this page.',
        previewFallback: 'Student feedback will appear here soon.',
        featuredLabel: 'Featured student',
        studentsCountLabel: 'Total students',
        currentPageLabel: 'Current page',
        currentViewLabel: 'Shown now',
        latestStoriesLabel: 'Student stories',
        openProfileLabel: 'Open profile',
        open: 'Details',
        close: 'Close',
        emptyContent: 'Student feedback has not been added.'
      },
      employeeProfilePage: {
        eyebrow: 'EMPLOYEE PORTFOLIO',
        notFoundTitle: 'Profile not found',
        notFoundText: 'The requested employee profile does not exist or is currently inactive.',
        backHome: 'Back to home',
        homeLabel: 'Home page',
        attachedFacultyPage: 'Faculty page',
        attachedDepartmentPage: 'Department page',
        attachedSectionPage: 'Section page',
        attachLabels: {
          faculty: 'Faculty',
          department: 'Department',
          section: 'Section'
        },
        profileFallback: 'Employee profile',
        profileSectionLabel: 'PROFILE',
        emptyContent: 'Detailed information for this employee has not been added yet.',
        portfolioBadge: 'Portfolio',
        portfolioTitle: 'Employee profile',
        portfolioDescription: 'The selected employee’s position, attached page, and detailed information are shown here.',
        telegram: 'Telegram',
        instagram: 'Instagram'
      },
      administrationPage: {
        eyebrow: 'UNIVERSITY ADMINISTRATION',
        title: 'Administration',
        description: 'Meet the university leadership and administration team.',
        featuredLabel: 'Featured profile',
        membersLabel: 'Administration members',
        openProfile: 'Open profile',
        contactLabel: 'Contact',
        activeLabel: 'Active profiles',
        leadershipLabel: 'Leadership roles',
        unitsLabel: 'Attached units',
        emptyTitle: 'Administration profiles are not ready yet',
        emptyText: 'The administration team will be published here soon.',
        fallbackPosition: 'Administration member',
        readMore: 'Learn more',
        administrationBadge: 'Administration',
        quickContact: 'Quick contact',
        portfolioLabel: 'Portfolio',
        emailLabel: 'Email',
        receptionLabel: 'Reception hours',
        phoneLabel: 'Phone'
      },
      admissionPage: {
        label: 'ADMISSION 2024',
        title: 'Admission 2024',
        description: 'Admission information entered in the admin panel is displayed on this page.',
        emptyContent: 'Admission information has not been added yet.',
        action: 'Apply now'
      }
    },
    home: {
      heroBanner: {
        primaryButton: 'Learn more',
        secondaryButton: 'View',
        ariaLabel: 'KIUF banners',
        slideLabel: 'Banner',
        pauseSlides: 'Pause slideshow',
        resumeSlides: 'Resume slideshow',
        previousSlide: 'Previous slide',
        nextSlide: 'Next slide'
      },
      heroFeatures: {
        ariaLabel: 'KIUF advantages'
      },
      homeInfo: {
        newsTitle: 'News',
        directionsTitle: 'Directions',
        seeAll: 'View all',
        noDate: 'No date',
        newsEmptyTitle: 'No news has been added yet.',
        newsEmptyAction: 'Go to section',
        directionsEmptyTitle: 'No directions have been added yet.',
        directionsEmptyAction: 'Go to section',
        directionsPromoTag: 'Directions',
        directionsPromoTitle: 'Directions will appear here',
        directionsPromoText:
          'After directions are added in the admin panel, this section will update automatically.',
        facultyFallbackTitle: 'Faculty',
        newsFallbackTitle: 'News item',
        admissionTitle: 'Admission 2024',
        admissionText: 'Apply now and take the first step toward your future!',
        admissionButton: 'Online application',
        detailsAction: 'Details',
        directionPromoFallback: 'Open the detailed information for this direction.',
        directionOrderTag: (order) => `Direction ${order}`,
        departmentCountTag: (departmentsCount) => `${departmentsCount} departments`,
        facultyPromoText: (departmentsCount) =>
          `Explore this faculty with ${departmentsCount} departments in detail.`
      },
      rector: {
        miniTitle: 'RECTOR’S SPEECH',
        defaultTitle: 'Rector’s address',
       
        cta: 'Learn more',
        alt: 'University rector',
        defaultName: 'Rector'
      },
      studentAnnouncementStats: {
        announcementsTitle: 'Announcements',
        studentsTitle: 'High-Achieving Students',
        seeAll: 'View all',
        announcementsEmptyTitle: 'No announcements yet',
        announcementsEmptyText: 'New announcements will appear here after they are added.',
        studentsEmptyTitle: 'Students have not been added yet',
        studentsEmptyText: 'Students added through the admin panel will be shown here.',
        details: 'Details',
        studentFallback: 'Student feedback will be published soon.'
      },
      partners: {
        sectionLabel: 'International cooperation',
        sectionTitle: 'Our partners',
        seeAll: 'View all',
        description:
          'KIUF is expanding academic exchange, joint projects, and international opportunities for students together with partner universities.',
        ariaLabel: 'Our international partners',
        siteVisitSuffix: 'visit website',
        logoSuffix: 'logo'
      },
      statistics: {
        label: 'KEY FIGURES',
        title: 'Student and staff scale'
      }
    },
    footer: {
      brandDescription:
        'KIUF is an educational bridge between Uzbekistan and Korea. Modern education, international cooperation, and a confident step toward the future.',
      columns: [
        {
          title: 'University',
          links: ['About us', 'Management', 'Structure', 'Vacancies']
        }
      ],
      contactTitle: 'Contact',
      addressLabel: 'Address:',
      addressValue: '55-B A. Navoiy Street, Fergana',
      phoneLabel: 'Phone:',
      phoneValue: '+998954019454, +998954019457',
      emailLabel: 'Email:',
      emailValue: 'info@ukiu.uz',
      hoursLabel: 'Working hours:',
      hoursValue: 'Monday - Friday, 8:00 to 18:00',
      applyButton: 'Submit online application',
      copyright: '© 2024 KIUF. All rights reserved.',
      privacy: 'Privacy policy',
      terms: 'Terms of use',
      mapTitle: 'KIUF map'
    }
  },
  ko: {
    navbar: {
      topbarInfo: {
        location: '페르가나시 A. 나보이 거리 55-B',
        phone: '+998954019454, +998954019457',
        email: 'info@ukiu.uz'
      },
      topbarLinks: {
        lms: 'LMS',
        hemis: 'HEMIS',
        corporateEmail: 'KORPORATIV POCHTA',
        eLibrary: 'E-KUTUBXONA'
      },
      brand: {
        sub: 'Korea International University in Fergana',
        korean: '우즈베키스탄 한국국제대학교'
      },
      contact: '문의',
      openContact: '문의 창 열기',
      mobileMenu: '메뉴',
      openSectionSuffix: '섹션 열기'
    },
    academicSidebar: {
      title: '학사 메뉴',
      announcementsTitle: '대학 공지사항',
      viewAll: '전체보기',
      emptyAnnouncements: '공지사항이 아직 없습니다.',
      searchPlaceholder: '메뉴 검색',
      searchEmpty: '일치하는 메뉴가 없습니다.',
      items: {
        faculties: '학부',
        departments: '학과',
        sections: '부서',
        partners: '국제 협력',
        news: '뉴스',
        administration: '행정팀'
      }
    },
    pages: {
      dynamicPage: {
        label: 'KIUF 페이지',
        notFoundTitle: '페이지를 찾을 수 없습니다',
        notFoundText: '요청한 페이지가 없거나 현재 비활성 상태입니다.',
        backHome: '홈으로 돌아가기',
        intro: '정보는 페이지에 저장된 순서 그대로 표시됩니다.',
        emptyContent: '이 페이지에는 아직 내용이 등록되지 않았습니다.'
      },
      menuContent: {
        label: '메뉴 정보',
        notFoundTitle: '메뉴를 찾을 수 없습니다',
        notFoundText: '요청한 메뉴가 없거나 현재 비활성 상태입니다.',
        backHome: '홈으로 돌아가기',
        intro: '',
        emptyContent: '이 메뉴에는 아직 내용이 등록되지 않았습니다.'
      },
      linkedInfoTable: {
        eyebrow: '구성 페이지',
        action: '열기'
      },
      fileAttachments: {
        eyebrow: '첨부 파일',
        title: '다운로드 문서',
        action: '다운로드',
        typeLabel: '형식',
        sizeLabel: '크기',
        defaultTitle: '파일'
      },
      innerBanner: {
        newsDetail: { eyebrow: 'KIUF 뉴스', title: '뉴스 상세' },
        announcementDetail: { eyebrow: 'KIUF 공지사항', title: '공지 상세' },
        dynamicPage: { eyebrow: 'KIUF 페이지', title: '페이지 상세' },
        menuPage: { eyebrow: 'KIUF 메뉴', title: '메뉴 페이지' },
        employeeProfile: { eyebrow: '직원 포트폴리오', title: '직원 프로필' },
        administration: {
          eyebrow: '대학교 행정팀',
          title: '행정팀',
          description: '대학교 리더십과 행정 구성원을 만나보세요.'
        },
        newsList: { eyebrow: 'KIUF 뉴스', title: '전체 뉴스' },
        announcementsList: { eyebrow: 'KIUF 공지사항', title: '전체 공지사항' },
        admission: { eyebrow: '입학', title: '입학 2024', description: '최신 입학 정보를 확인하세요.' },
        partners: { eyebrow: '국제 협력', title: '글로벌 교육 파트너' },
        facultyDetail: { eyebrow: '학사 구조', title: '학부 페이지' },
        departmentDetail: { eyebrow: '학사 구조', title: '학과 페이지' },
        sectionDetail: { eyebrow: '대학교 부서', title: '부서 페이지' },
        academicBreadcrumbs: {
          faculty: '학부 페이지',
          department: '학과 페이지',
          section: '부서 페이지'
        },
        sectionsList: { eyebrow: '대학교 부서', title: '전체 부서' },
        facultiesList: { eyebrow: '학사 구조', title: '전체 학부' },
        departmentsList: { eyebrow: '학사 구조', title: '학부 및 학과' },
        students: { eyebrow: 'KIUF 학생', title: '우리 학생들' },
        rector: { eyebrow: '대학교 리더십', title: '열린 대화는 신뢰 있는 미래의 기반입니다' },
        default: { eyebrow: 'KIUF', title: '대학교 페이지' }
      },
      facultiesList: {
        itemPrefix: '학부',
        details: '자세히'
      },
      sectionsList: {
        eyebrow: '대학교 부서',
        title: '전체 부서',
        description: '대학교 부서에 대한 자세한 정보를 확인하세요.',
        emptyTitle: '아직 등록된 부서가 없습니다',
        emptyText: '관리자 패널에 부서를 추가하면 이 페이지에 목록으로 표시됩니다.',
        placeholder: '부서',
        badge: '부서',
        openLabel: '부서 페이지 열기',
        details: '자세히 보기',
        previous: '이전',
        next: '다음'
      },
      departmentsList: {
        departmentsCount: (count) => `${count}개 학과 운영 중`,
        openFaculty: '학부 페이지 열기',
        openDepartment: '학과 페이지 열기'
      },
      academicEntity: {
        meta: {
          faculty: {
            eyebrow: '학사 구조',
            label: '학부',
            backLabel: '전체 학부',
            emptyTitle: '학부를 찾을 수 없습니다'
          },
          department: {
            eyebrow: '학사 구조',
            label: '학과',
            backLabel: '전체 학과',
            emptyTitle: '학과를 찾을 수 없습니다'
          },
          section: {
            eyebrow: '대학교 부서',
            label: '부서',
            backLabel: '전체 부서',
            emptyTitle: '부서를 찾을 수 없습니다'
          }
        },
        panelFallbackTitle: '섹션',
        summary: {
          pageType: '페이지 유형',
          departments: '학과',
          attachedMenu: '연결 메뉴',
          faculty: '학부',
          status: '상태',
          active: '활성',
          inactive: '비활성'
        },
        emptyDepartments: '이 학부에는 아직 학과가 등록되지 않았습니다.',
        departmentBadge: '학과',
        departmentDescriptionFallback: '학과 페이지에서 자세한 정보를 확인할 수 있습니다.',
        attachedDepartmentsLabel: '연결된 학과',
        attachedDepartmentsTitle: '학과 목록',
        attachedDirectionsTitle: '연결된 전공 안내',
        directionsPanelTitle: '전공 안내',
        emptyDirections: '이 학과에는 아직 전공 안내가 등록되지 않았습니다.',
        directionBadge: '전공',
        directionLinkLabel: '링크 열기',
        directionEmptyContent: '이 전공 안내의 상세 정보가 아직 등록되지 않았습니다.',
        directionNoLinkText: '연결된 링크가 없습니다.',
        entityInfoLabel: '학부 정보',
        emptyFacultyContent: '이 학부의 본문이 아직 등록되지 않았습니다.',
        emptyPageContent: '이 페이지의 본문이 아직 등록되지 않았습니다.',
        missingFacultyInfo: '이 학과에 대한 학부 정보를 찾을 수 없습니다.',
        relatedFacultyLabel: '관련 학부',
        relatedFacultyFallback: '이 학부의 자세한 정보는 별도 페이지에서 확인할 수 있습니다.',
        openFacultyPage: '학부 페이지 열기',
        emptySections: '부서 목록이 아직 등록되지 않았습니다.',
        sectionBadge: '부서',
        sectionFallback: '부서 페이지에서 자세한 정보를 확인할 수 있습니다.',
        emptyEmployees: '이 페이지에 연결된 직원이 아직 없습니다.',
        employeeFallbackPosition: '직원',
        employeeProfileOpen: '프로필 보기',
        emptyMenuContent: '이 메뉴의 본문이 아직 등록되지 않았습니다.',
        notFoundText: '요청한 페이지가 없거나 현재 비활성 상태입니다.',
        pageMenuTitle: '페이지 메뉴',
        activeMenuDescription: '선택한 오른쪽 메뉴 섹션의 정보가 아래에 표시됩니다.',
        facultyOverviewDescription: '먼저 연결된 학과가 표시되고, 그 아래에 학부 정보가 표시됩니다.',
        defaultTabTitle: '정보',
        facultyAboutTitle: '학부 소개',
        lastUpdatedLabel: '최근 업데이트',
        leaderCardTitles: {
          faculty: '학부장',
          department: '학과장',
          section: '부서장'
        },
        leaderInlineLabels: {
          faculty: '학부장',
          department: '학과장',
          section: '부서장'
        },
        leaderInfoTitle: '정보',
        leaderInfoPositionLabel: '직위',
        leaderInfoPhoneLabel: '전화',
        leaderInfoEmailLabel: '이메일',
        leaderInfoReceptionLabel: '상담 시간',
        leaderInfoTelegramLabel: 'Telegram',
        leaderInfoInstagramLabel: 'Instagram',
        leaderContactMissing: '아직 정보가 등록되지 않았습니다',
        leaderEmptyText: '책임자 정보가 아직 등록되지 않았습니다.',
        leaderProfileAction: '자세히 보기',
        menuFilesEyebrow: '첨부 파일',
        menuFilesTitle: '다운로드 문서',
        menuFilesAction: '다운로드',
        menuFilesTypeLabel: '형식',
        menuFilesSizeLabel: '크기',
        pageOverviewDescription: (label) => `${label} 페이지의 기본 정보가 아래에 표시됩니다.`
      },
      partnersPage: {
        heroDescription: 'KIUF는 한국의 주요 대학들과 함께 학술 협력, 교환 프로그램, 연구 프로젝트를 지속적으로 확대하고 있습니다.',
        heroAction: '파트너 보기',
        partnersStat: '파트너 대학',
        secondaryStat: '학술 방향',
        listEyebrow: '파트너 목록',
        listTitle: '대학교',
        listDescription: '각 파트너 대학 카드에서 해당 대학의 공식 웹사이트로 이동할 수 있습니다.',
        partnerBadge: '파트너 대학',
        officialSite: '공식 사이트',
        formatsEyebrow: '협력 분야',
        formatsTitle: '주요 형식',
        formatsDescription: '국제 협력은 대학의 학술, 교육, 실무 활동에서 중요한 역할을 합니다.',
        collaborationAreas: [
          '학술 교류 및 공동 프로그램',
          '교수진과의 경험 교류',
          '연구 및 혁신 프로젝트 협력',
          '학생을 위한 국제 교육 환경'
        ]
      },
      newsList: {
        details: '자세히',
        previous: '이전',
        next: '다음'
      },
      newsDetail: {
        notFoundTitle: '뉴스를 찾을 수 없습니다',
        backToList: '전체 뉴스',
        label: 'KIUF 뉴스',
        emptyContent: '뉴스 본문이 없습니다.'
      },
      announcementsList: {
        eyebrow: 'KIUF 공지사항',
        title: '전체 공지사항',
        description: '대학교의 공식 공지와 중요한 안내입니다.',
        details: '자세히',
        previous: '이전',
        next: '다음'
      },
      announcementDetail: {
        notFoundTitle: '공지를 찾을 수 없습니다',
        backToList: '전체 공지사항',
        label: '공식 공지',
        emptyContent: '공지 본문이 없습니다.'
      },
      studentsPage: {
        eyebrow: 'KIUF 학생',
        title: '우리 학생들',
        description: 'KIUF 학생들은 지식, 실무 경험, 국제적 기회를 통해 각자의 분야에서 성장하고 있습니다.',
        emptyTitle: '아직 등록된 학생이 없습니다',
        emptyText: '관리자 패널에 학생을 추가하면 사진, 전공, 후기 정보가 이 페이지에 표시됩니다.',
        previewFallback: '학생 후기가 곧 여기에 표시됩니다.',
        featuredLabel: '선택된 학생',
        studentsCountLabel: '전체 학생',
        currentPageLabel: '현재 페이지',
        currentViewLabel: '표시 중',
        latestStoriesLabel: '학생 이야기',
        openProfileLabel: '프로필 열기',
        open: '자세히',
        close: '닫기',
        emptyContent: '학생 후기가 등록되지 않았습니다.'
      },
      employeeProfilePage: {
        eyebrow: '직원 포트폴리오',
        notFoundTitle: '프로필을 찾을 수 없습니다',
        notFoundText: '요청한 직원 프로필이 없거나 현재 비활성 상태입니다.',
        backHome: '홈으로 돌아가기',
        homeLabel: '홈페이지',
        attachedFacultyPage: '학부 페이지',
        attachedDepartmentPage: '학과 페이지',
        attachedSectionPage: '부서 페이지',
        attachLabels: {
          faculty: '학부',
          department: '학과',
          section: '부서'
        },
        profileFallback: '직원 프로필',
        profileSectionLabel: 'PROFILE',
        emptyContent: '이 직원에 대한 상세 정보가 아직 등록되지 않았습니다.',
        portfolioBadge: '포트폴리오',
        portfolioTitle: '직원 프로필',
        portfolioDescription: '선택한 직원의 직위, 연결된 페이지, 상세 정보가 이곳에 표시됩니다.',
        telegram: 'Telegram',
        instagram: 'Instagram'
      },
      administrationPage: {
        eyebrow: '대학교 행정팀',
        title: '행정팀',
        description: '대학교 리더십과 행정 구성원을 만나보세요.',
        featuredLabel: '대표 프로필',
        membersLabel: '행정팀 구성원',
        openProfile: '프로필 열기',
        contactLabel: '연락',
        activeLabel: '활성 프로필',
        leadershipLabel: '리더십 역할',
        unitsLabel: '연결 부서',
        emptyTitle: '행정팀 프로필이 아직 준비되지 않았습니다',
        emptyText: '행정팀 정보가 곧 이곳에 게시됩니다.',
        fallbackPosition: '행정팀 구성원',
        readMore: '자세히',
        administrationBadge: '행정팀',
        quickContact: '빠른 연락',
        portfolioLabel: '포트폴리오',
        emailLabel: '이메일',
        receptionLabel: '상담 시간',
        phoneLabel: '전화'
      },
      admissionPage: {
        label: '입학 2024',
        title: '입학 2024',
        description: '관리자 패널에 입력된 입학 정보가 이 페이지에 표시됩니다.',
        emptyContent: '입학 정보가 아직 추가되지 않았습니다.',
        action: '지원하기'
      }
    },
    home: {
      heroBanner: {
        primaryButton: '자세히 보기',
        secondaryButton: '보기',
        ariaLabel: 'KIUF 배너',
        slideLabel: '배너',
        pauseSlides: '자동 전환 일시 정지',
        resumeSlides: '자동 전환 재개',
        previousSlide: '이전 슬라이드',
        nextSlide: '다음 슬라이드'
      },
      heroFeatures: {
        ariaLabel: 'KIUF의 장점'
      },
      homeInfo: {
        newsTitle: '뉴스',
        directionsTitle: '전공 안내',
        seeAll: '전체보기',
        noDate: '날짜 없음',
        newsEmptyTitle: '아직 등록된 뉴스가 없습니다.',
        newsEmptyAction: '섹션으로 이동',
        directionsEmptyTitle: '아직 등록된 학부가 없습니다.',
        directionsEmptyAction: '섹션으로 이동',
        directionsPromoTag: '학부',
        directionsPromoTitle: '전공 안내가 여기에 표시됩니다',
        directionsPromoText:
          '관리자 패널에서 학부를 추가하면 이 섹션이 자동으로 업데이트됩니다.',
        facultyFallbackTitle: '학부',
        newsFallbackTitle: '뉴스',
        admissionTitle: '입학 2024',
        admissionText: '지금 지원하고 미래를 향한 첫걸음을 시작하세요!',
        admissionButton: '온라인 지원',
        departmentCountTag: (departmentsCount) => `${departmentsCount}개 학과`,
        facultyPromoText: (departmentsCount) =>
          `${departmentsCount}개의 학과로 구성된 이 학부를 자세히 살펴보세요.`
      },
      rector: {
        miniTitle: '총장 인사말',
        defaultTitle: '총장 인사말',
        defaultExcerpt: '총장 인사말이 곧 게시됩니다.',
        cta: '자세히 보기',
        alt: '대학교 총장',
        defaultName: '총장'
      },
      studentAnnouncementStats: {
        announcementsTitle: '공지사항',
        studentsTitle: '우수 학생들',
        seeAll: '전체보기',
        announcementsEmptyTitle: '공지사항이 아직 없습니다',
        announcementsEmptyText: '새 공지사항이 추가되면 여기에 표시됩니다.',
        studentsEmptyTitle: '아직 학생 정보가 없습니다',
        studentsEmptyText: '관리자 패널에서 추가된 학생이 이 영역에 표시됩니다.',
        details: '자세히',
        studentFallback: '학생 후기가 곧 게시됩니다.'
      },
      partners: {
        sectionLabel: '국제 협력',
        sectionTitle: '우리 파트너',
        seeAll: '전체보기',
        description:
          'KIUF는 파트너 대학들과 함께 학술 교류, 공동 프로젝트, 그리고 학생들을 위한 국제적 기회를 확대하고 있습니다.',
        ariaLabel: '국제 파트너 기관',
        siteVisitSuffix: '웹사이트로 이동',
        logoSuffix: '로고'
      },
      statistics: {
        label: '주요 수치',
        title: '학생 및 교직원 규모'
      }
    },
    footer: {
      brandDescription:
        'KIUF는 우즈베키스탄과 한국을 잇는 교육의 다리입니다. 현대적인 교육, 국제 협력, 그리고 미래를 향한 확신 있는 발걸음을 제공합니다.',
      columns: [
        {
          title: '대학교',
          links: ['학교 소개', '리더십', '구조', '채용']
        }
      ],
      contactTitle: '연락처',
      addressLabel: '주소:',
      addressValue: '페르가나시 A. 나보이 거리 55-B',
      phoneLabel: '전화:',
      phoneValue: '+998954019454, +998954019457',
      emailLabel: '이메일:',
      emailValue: 'info@ukiu.uz',
      hoursLabel: '운영 시간:',
      hoursValue: '월요일 - 금요일, 8:00 - 18:00',
      applyButton: '온라인 지원서 제출',
      copyright: '© 2024 KIUF. 모든 권리 보유.',
      privacy: '개인정보 처리방침',
      terms: '이용 약관',
      mapTitle: 'KIUF 지도'
    }
  }
};

export function getSiteMessages(languageCode = DEFAULT_LANGUAGE_CODE) {
  const normalizedCode = normalizeLanguageCode(languageCode);

  return siteMessages[normalizedCode] || siteMessages[DEFAULT_LANGUAGE_CODE];
}
